<template>
  <div class="infoContBan" :style="{ backgroundColor: info.tips }">
    <div
      class="m-smallBan"
      :style="{
        backgroundImage: 'url(' + require('../../assets/img/ico_24.jpg') + ')'
      }"
    >
      <div class="m-smallBan-cap">
        {{ menu.subTitle }}
      </div>
    </div>
    <div class="g-box">
      <EditCont :content="info.content" class="infoContBan-bd" />
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";
import EditCont from "../../components/EditCont";

export default {
  mixins: [pageMain_mx],
  data() {
    return {};
  },
  components: { EditCont },
  mounted() {},
  methods: {
    init() {
      this.params = this.$route.params;
      this.getInfo();
    }
  }
};
</script>
<style lang="less">
.infoContBan {
  .g-box {
    padding: 70px 0;
  }
}
.infoContBan-bd {
  .ql-editor {
    color: #606060;
  }
}
</style>
